import { createContext, useContext, useState, useEffect } from "react";
import ApiMethods from "../../ApiManager/ApiMethods";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const fetchUser = async () => {
    try {
      const data = {
        token: localStorage.getItem("fcm_token"),
      };
      const id = localStorage.getItem("id");
      const response = await ApiMethods.get(`client/${id}`, data);
      const user = response;
      localStorage.setItem("user", JSON.stringify(user));
      console.log("response", user);
    } catch (err) {}
  };
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  useEffect(() => {
    // if (user) {
    //   localStorage.setItem("user", JSON.stringify(user));
    // } else {
    //   localStorage.removeItem("user");
    // }
    fetchUser();
  }, [user]);

  const logout = () => {
    setUser(null);
  };

  return (
    <UserContext.Provider value={{ user, setUser, logout }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
